var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-secondary',{staticClass:"pc-exercise",attrs:{"header":_vm.headerOptions,"desktop-side-bar":true}},[(_vm.loaded)?_c('container-single-exercise',{on:{"header-text":function($event){return _vm.setHeaderText($event)}}}):_c('ContainerSingleExerciseSkeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }